import { addQueryString, fetchJson as fetch } from '@primitives/fetch.utils'
import { getHost, type Chain, type Options } from '..'
import * as Schema from './schema'

export type * from './schema'

export async function getSoftLiqRatios(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(
    `${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/soft_liquidation_ratio`,
  )

  return Schema.getSoftLiqRatiosResponse.parse(response)
}

export async function getLiqsDetailed(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(
    `${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/history/detailed`,
  )

  return Schema.getLiqsDetailedResponse.parse(response)
}

export async function getLiqsAggregate(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(
    `${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/history/aggregated`,
  )

  return Schema.getLiqsAggregateResponse.parse(response)
}

export async function getLiqOverview(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(
    `${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/overview?fetch_on_chain=true`,
  )

  return Schema.getLiqOverviewResponse.parse(response)
}

export async function getLiqLosses(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(`${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/losses/history`)

  return Schema.getLiqLossesResponse.parse(response)
}

export async function getLiqHealthDeciles(
  endpointParam: Schema.Endpoint,
  blockchainId: Chain,
  marketAddr: string,
  options?: Options,
) {
  const host = getHost(options)
  Schema.endpoint.parse(endpointParam)
  const response = await fetch(
    `${host}/v1/${endpointParam}/liquidations/${blockchainId}/${marketAddr}/health/distribution`,
  )

  return Schema.getLiqHealthDecilesResponse.parse(response)
}

export async function getTotalOverview(
  { endpoint: endpointParam, ...params }: { endpoint: Schema.Endpoint; fetch_on_chain?: boolean },
  options?: Options,
) {
  params.fetch_on_chain ??= true
  Schema.endpoint.parse(endpointParam)

  const host = getHost(options)
  const response = await fetch(`${host}/v1/${endpointParam}/liquidations/total_overview${addQueryString(params)}`)

  return Schema.getTotalOverviewResponse.parse(response)
}

export async function getBadDebt(
  { endpoint: endpointParam, ...params }: { endpoint: Schema.Endpoint; fetch_on_chain?: boolean },
  options?: Options,
) {
  params.fetch_on_chain ??= true
  Schema.endpoint.parse(endpointParam)

  const host = getHost(options)
  const response = await fetch(`${host}/v1/${endpointParam}/liquidations/bad_debt${addQueryString(params)}`)

  return Schema.getBadDebtResponse.parse(response)
}
